// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

/* eslint-disable spire/fenced-imports */
import Tippy, { TippyProps } from "@tippyjs/react";

import React, { useState } from "react";

export type LazyTippyProps = TippyProps;

const LazyTippy = (props: LazyTippyProps) => {
    const [mounted, setMounted] = useState(false);

    const lazyPlugin = {
        fn: () => ({
            onShow: () => {
                setMounted(true);
                document.querySelectorAll("select").forEach(select => select.blur());
            },
            onHidden: () => setMounted(false),
        }),
    };

    const computedProps = { ...props };

    computedProps.plugins = [lazyPlugin, ...(props.plugins || [])];

    if (props.render) {
        const render = props.render;
        computedProps.render = (...args) => (mounted ? render(...args) : "");
    } else {
        computedProps.content = mounted ? props.content : "";
    }

    return <Tippy {...computedProps} />;
};

export default LazyTippy;
